import {
    Navigate, Outlet,
} from 'react-router-dom'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    RatesDomains,
} from 'app/enums/domain.enums'
import ARateCardsRoutes from './ARateCards/ARateCards.routes'
import CRateCards from './RateCards'

export default [
    {
        path: RatesDomains.ARateCards,
        element: <Outlet />,
        children: ARateCardsRoutes,
    },
    {
        path: `${RatesDomains.CRateCards}/${CommonRoutes.Asterisk}`,
        element: <CRateCards />,
    },
    {
        path: CommonRoutes.Asterisk,
        element: <Navigate
            to={RatesDomains.ARateCards}
            replace
        />,
    },
]
